import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAudioStore } from '../state/audioStore.ts';
import { audio, music, greyBed } from './audioEngine.ts';
import { prepareSunsetMusic, syncSunsetPreferences, setSunsetMusicRoute, disposeSunsetMusic } from './sunsetMusic.ts';

/**
 * Hook: keeps the global audio engine in sync with the persisted audio store.
 * Mount once near the app root (e.g. in App.tsx or Landing.tsx).
 */
export function useAudioInit() {
  const volume = useAudioStore((s) => s.sfxVolume);
  const muted = useAudioStore((s) => s.muted);
  const musicVolume = useAudioStore((s) => s.musicVolume);
  const musicEnabled = useAudioStore((s) => s.musicEnabled);
  const { pathname } = useLocation();

  useEffect(() => {
    music.stop(true);
    // Only the tiny owner loads globally. Regional metadata waits until the
    // existing music controls are shown; audio still requires explicit Play.
    void prepareSunsetMusic();
    return disposeSunsetMusic;
  }, []);
  useEffect(() => { setSunsetMusicRoute(pathname); }, [pathname]);

  useEffect(() => {
    audio.setVolume(volume);
  }, [volume]);

  useEffect(() => {
    audio.setMuted(muted);
    // Procedural SFX and the exclusive Grey Hour owner use the canonical mute.
    music.setMusicMuted(muted);
    greyBed.setMusicMuted(muted);
  }, [muted]);

  useEffect(() => {
    music.setMusicVolume(musicVolume);
    greyBed.setMusicVolume(musicVolume);
  }, [musicVolume]);

  useEffect(() => {
    syncSunsetPreferences();
  }, [musicEnabled, musicVolume, muted]);
}
